import {
  ChangeEventHandler,
  FunctionComponent,
  KeyboardEventHandler,
  useEffect,
  useRef,
  useState,
} from 'react';
import { DraftPlaceholderTextConfiguration } from '@/types';
import { parseFloatOrZero } from '@/utils/parseFloatOrZero';
import './PlaceholderControls.scss';

interface Props {
  configuration: DraftPlaceholderTextConfiguration;
  onWidthChange: (width: number) => void;
}

export const PlaceholderControls: FunctionComponent<Props> = ({ configuration, onWidthChange }) => {
  const widthInput = useRef<HTMLInputElement | null>(null);
  const [width, setWidth] = useState(configuration.placeholderSize.width);

  useEffect(() => {
    setWidth(configuration.placeholderSize.width);
  }, [configuration.placeholderSize]);

  const handleSubmit: KeyboardEventHandler = (event) => {
    if (event.key === 'Enter') {
      onWidthChange(parseFloatOrZero(widthInput.current?.value));
    }
  };

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    setWidth(parseFloat(event.target.value));
  };

  return (
    <div className="placeholder-controls">
      <label className="placeholder-controls__label">
        Placeholder Width
        <input
          className="placeholder-controls__input"
          ref={widthInput}
          value={width}
          onKeyDown={handleSubmit}
          onChange={handleChange}
          onFocus={() => widthInput.current?.select()}
        />
        {configuration.placeholderSize.unit}
      </label>
    </div>
  );
};
